import script from './component-lib.esm57.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Amazon'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M28.925 27.663c-3.506 2.587-8.581 3.962-12.956 3.962-6.131 0-11.65-2.262-15.825-6.038-0.325-0.294-0.038-0.7 0.356-0.469 4.506 2.625 10.081 4.2 15.838 4.2 3.881 0 8.15-0.806 12.081-2.475 0.587-0.25 1.087 0.394 0.506 0.819z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.381 26c-0.45-0.575-2.962-0.275-4.094-0.137-0.344 0.038-0.394-0.256-0.087-0.475 2.006-1.406 5.294-1 5.675-0.531 0.387 0.475-0.1 3.769-1.981 5.344-0.288 0.244-0.563 0.113-0.438-0.206 0.431-1.056 1.375-3.419 0.925-3.994z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.106 23.675l0.006 0.006c0.775-0.681 2.169-1.9 2.956-2.556 0.313-0.25 0.256-0.669 0.012-1.019-0.706-0.975-1.456-1.769-1.456-3.569v-6c0-2.544 0.175-4.875-1.694-6.625-1.475-1.413-3.925-1.913-5.8-1.913-3.662 0-7.75 1.369-8.606 5.894-0.094 0.481 0.263 0.738 0.575 0.806l3.731 0.406c0.35-0.019 0.6-0.363 0.669-0.713 0.319-1.556 1.625-2.313 3.094-2.313 0.794 0 1.694 0.287 2.163 1 0.538 0.794 0.469 1.875 0.469 2.794v0.5c-2.231 0.25-5.15 0.412-7.238 1.331-2.412 1.044-4.106 3.169-4.106 6.294 0 4 2.519 6 5.763 6 2.738 0 4.231-0.644 6.344-2.806 0.7 1.012 0.925 1.506 2.206 2.569 0.294 0.156 0.656 0.144 0.913-0.087zM18.225 14.287c0 1.5 0.038 2.75-0.719 4.081-0.613 1.087-1.581 1.75-2.662 1.75-1.475 0-2.338-1.125-2.338-2.788 0-3.281 2.944-3.875 5.725-3.875v0.831z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var AmazonIcon = __vue_component__;
export { AmazonIcon as default };